import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Drawer,
  SwipeableDrawer,
  AppBar,
  Toolbar,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
  Button,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LogoutIcon from "@mui/icons-material/Logout";
import HistoryIcon from "@mui/icons-material/History";
import PersonIcon from "@mui/icons-material/Person";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import BusinessIcon from "@mui/icons-material/Business";
import SecurityIcon from "@mui/icons-material/Security";
import SchoolIcon from "@mui/icons-material/School";
import GroupIcon from "@mui/icons-material/Group";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CategoryIcon from "@mui/icons-material/Category";
import KeyRoundIcon from "@mui/icons-material/VpnKey";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import BranchIcon from "@mui/icons-material/AccountTree";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Dashboard from "../../features/dashboard/Dashboard";
import Assesment from "../../features/assessments/AssessmentList";
import Instruction from "../../features/instructions/Instruction";
import Setting from "../../features/question-papers/QuestionBankList";
import Footer from "../../components/Footer";
import Test from "../../features/test-runner/Test";
import UserReview from "../../features/reviews/UserReview";
import TestDetail from "../../features/reviews/TestDetail";
import Institutes from "../../features/institutes/InstitutesList";
import InstituteAdmin from "../../features/institute-admins/InstituteAdminList";
import StudentsList from "../../features/students/StudentsList";
import SuperAdminsList from "../../features/super-admins/SuperAdminsList";
import TrainersList from "../../features/trainers/TrainersList";
import BatchesList from "../../features/batches/BatchesList";
import ViewBatch from "../../features/batches/ViewBatch";
import { useSnackbar } from "../../providers/SnackbarProvider";
import { stopTokenRefresh } from "../../api/client";
import AddInstitute from "../../features/institutes/AddInstitute";
import AddInstituteAdmin from "../../features/institute-admins/AddInstituteAdmin";
import AddTrainer from "../../features/trainers/AddTrainer";
import AddStudent from "../../features/students/AddStudent";
import AddCategory from "../../features/categories/AddCategory";
import Category from "../../features/categories/Category";
import ViewTestDetails from "../../features/assessments/ViewTestDetails";
import AddSuperAdmin from "../../features/super-admins/AddSuperAdmin";
import ViewStudent from "../../features/students/ViewStudent";
import ViewCategory from "../../features/categories/ViewCategory";
import TrainerViewReview from "../../features/trainers/TrainerViewReview";
import StudentsResultList from "../../features/students/StudentsResultList";
import ViewTrainer from "../../features/trainers/ViewTrainer";
import ViewInstituteAdmin from "../../features/institute-admins/ViewInstituteAdmin";
import ViewSuperAdmin from "../../features/super-admins/ViewSuperAdmin";
import ViewInstitute from "../../features/institutes/ViewInstitute";
import ChangePassword from "../../features/auth/ChangePassword";
import QuestionBankView from "../../features/question-papers/QuestionBankView";
import DescriptionIcon from "@mui/icons-material/Description";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import CloseIcon from "@mui/icons-material/Close";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import ArticleIcon from "@mui/icons-material/Article";
import QuetionPaperPreview from "../../features/question-papers/QuestionPaperPreview";
import PreviewTable from "../../features/question-papers/PreviewTable";
import AuditLogs from "../../features/audit-logs/AuditLogs";
import AddSubcategory from "../../features/categories/AddSubcategory";
import Add from "../../features/categories/AddPart";
import QuestionPaperBuilder from "../../features/question-papers/QuestionPaperBuilder";
import CreateQuestionPaper from "../../features/question-papers/CreateQuestionPaper";
import AddQuestionsToPaper from "../../features/question-papers/create/AddQuestionsToPaper";
import QuestionPaperView from "../../features/question-papers/QuestionPaperView";
import Programs from "../../features/programs/Programs";
import ViewProgram from "../../features/programs/ViewProgram";
import ListAltIcon from "@mui/icons-material/ListAlt";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import TemplatesList from "../../features/question-papers/create/TemplatesList";
import TemplateCreate from "../../features/question-papers/create/TemplateCreate";
import LLMSettingsPanel from "../../features/llm-settings/LLMSettingsPanel";
import { useChangeableItems, getLabelByKey, useOrganizations, useSelectedOrganizationId } from "../../store/useDynamicLabel";
import { useDispatch } from "react-redux";
import { setSelectedOrganization, clearChangeableItems } from "../../store/changeableItemsSlice";
import { CalendarCheck, CalendarCheck2, MessagesSquare, PersonStandingIcon } from "lucide-react";
import InterviewList from "../../features/interviewer/InterviewerList";
import ViewInterviewer from "features/interviewer/ViewInterview";
import InterviewerHistory from "features/interviewer/InterviewerHistory";
import AddInterviewer from "features/interviewer/AddInterviewer";
import InterviewScheduler from "features/interview-scheduler/InterviewSchedulerList";
import AddInterviewScheduler from "features/interview-scheduler/AddInterviewScheduler";
import ViewInterviewScheduler from "features/interview-scheduler/ViewInterviewScheduler";
import { Feedback, FeedbackOutlined } from "@mui/icons-material";
import InterviewFeedbackList from "features/interview-feedback/InterviewFeedbackList";
import InterviewFeedback from "features/interview-feedback/InterviewFeedback";

// User Profile Dropdown Component
const UserProfileDropdown = ({
  handleLogout,
  isHovered,
  forceShow = false,
  onOpenLLMSettings,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate();

  const changeableItems = useChangeableItems();
  const getLabel = (itemKey) => getLabelByKey(changeableItems, itemKey);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const handleChangePassword = () => {
    console.log("Change Password clicked");
    navigate("/changePassword");
    setIsExpanded(false);
  };

  const handleLLMSettings = () => {
    // No navigation — swap the sidebar to the LLM Settings panel instead.
    onOpenLLMSettings?.();
    setIsExpanded(false);
  };

  const handleLogoutClick = () => {
    handleLogout();
    setIsExpanded(false);
  };

  const firstName = localStorage.getItem("firstName") || "User";
  const lastName = localStorage.getItem("lastName") || "";
  const role = localStorage.getItem("role") || "USER";

  const getRoleText = (role) => {
    switch (role) {
      case "STUDENT":
        return "Student";
      case "INSTITUTE_ADMIN":
        return "Institute Admin";
      case "SUPER_ADMIN":
        return "Super Admin";
      case "TRAINER":
        return "Trainer";
      default:
        return "User";
    }
  };

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      {/* Main container */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "12px",
          border: "1px solid #c1c1c6ff",
          boxShadow: 2,
          backgroundColor: "white",
          overflow: "hidden",
        }}
      >
        {/* Dropdown Menu Items - Now at the TOP */}
        <Box
          sx={{
            maxHeight: isExpanded && (isHovered || forceShow) ? "200px" : "0px",
            opacity: isExpanded && (isHovered || forceShow) ? 1 : 0,
            overflow: "hidden",
            transition: "all 0.3s ease-in-out",
            display: "flex",
            flexDirection: "column",
            order: 1, // This places it at the top in flex column
          }}
        >
          <Box
            onClick={handleChangePassword}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              p: 1.5,
              borderRadius: "6px",
              cursor: "pointer",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.05)",
              },
            }}
          >
            <KeyRoundIcon sx={{ color: "black", fontSize: 17 }} />
            <Typography sx={{ fontSize: "13px", color: "black" }}>
              Change Password
            </Typography>
          </Box>
          {role === "SUPER_ADMIN" && (
            <Box
              onClick={handleLLMSettings}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                p: 1.5,
                borderRadius: "6px",
                cursor: "pointer",
                transition: "all 0.3s ease-in-out",
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.05)",
                },
              }}
            >
              <SmartToyIcon sx={{ color: "black", fontSize: 17 }} />
              <Typography sx={{ fontSize: "13px", color: "black" }}>
                LLM Settings
              </Typography>
            </Box>
          )}
          <Box
            onClick={handleLogoutClick}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              p: 1.5,
              borderRadius: "6px",
              cursor: "pointer",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                backgroundColor: "rgba(244, 67, 54, 0.1)",
              },
            }}
          >
            <LogoutIcon sx={{ color: "black", fontSize: 17 }} />
            <Typography sx={{ fontSize: "13px", color: "black" }}>
              Logout
            </Typography>
          </Box>
        </Box>

        {/* Profile Card that acts as dropdown trigger - Now at the BOTTOM */}
        <Box
          onClick={handleToggle}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "white",
            color: "inherit",
            py: 2,
            px: 1,
            cursor: "pointer",
            transition: "all 0.3s ease-in-out",
            order: 2, // This places it at the bottom in flex column
            "&:hover": {
              backgroundColor: "#f0f9ff",
              transform: "scale(1.02)",
              boxShadow: 4,
            },
          }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Avatar
              sx={{
                bgcolor: isExpanded ? "white" : "white",
                color: isExpanded ? "#3b94f3ff" : "#1565c0",
                height: 30,
                width: 30,
                transition: "all 0.3s ease-in-out",
              }}
            >
              <PersonIcon />
            </Avatar>
            <Grid>
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#414651",
                  fontWeight: 600,
                  transition: "all 0.3s ease-in-out",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "120px",
                  opacity: isHovered || forceShow ? 1 : 0,
                  width: isHovered || forceShow ? "auto" : 0,
                }}
              >
                {firstName} {lastName}
              </Typography>
              <Typography
                sx={{
                  color: "#414651",
                  fontSize: "11px",
                  fontWeight: 500,
                  textTransform: "capitalize",
                  transition: "all 0.3s ease-in-out",
                  opacity: isHovered || forceShow ? 1 : 0,
                  width: isHovered || forceShow ? "auto" : 0,
                }}
              >
                {getLabel(role)}
              </Typography>
            </Grid>
          </Box>
          <Box display="flex" alignItems="center">
            <Box
              sx={{
                transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                transition: "all 0.3s ease-in-out",
                opacity: isHovered ? 1 : 0,
                width: isHovered ? "auto" : 0,
              }}
            >
              <ExpandMoreIcon
                sx={{
                  color: "black",
                  fontSize: 20,
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Overlay to close when clicking outside */}
      {isExpanded && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: -1,
          }}
          onClick={handleToggle}
        />
      )}
    </Box>
  );
};

const AuthenticatedRoutes = () => {

  const changeableItems = useChangeableItems();
  const getLabel = (itemKey) => getLabelByKey(changeableItems, itemKey);
  const organizations = useOrganizations();
  const selectedOrganizationId = useSelectedOrganizationId();
  const dispatch = useDispatch();
  // ===== states =====

  const location = useLocation();
  const hideFooter = location.pathname === "/test";
  const navigate = useNavigate();
  const [role, setRole] = useState(localStorage.getItem("role"));
  const organization = localStorage.getItem("organization_name");
  const isSuperAdmin = role === "SUPER_ADMIN";
  const [currentOrgIndex, setCurrentOrgIndex] = useState(0);

  // Sync currentOrgIndex with selectedOrganizationId
  useEffect(() => {
    if (selectedOrganizationId && organizations.length > 0) {
      const index = organizations.findIndex(org => org.id === selectedOrganizationId);
      if (index !== -1) {
        setCurrentOrgIndex(index);
      }
    }
  }, [selectedOrganizationId, organizations]);

  const handlePreviousOrg = () => {
    const newIndex = currentOrgIndex > 0 ? currentOrgIndex - 1 : organizations.length - 1;
    setCurrentOrgIndex(newIndex);
    dispatch(setSelectedOrganization(organizations[newIndex].id));
  };

  const handleNextOrg = () => {
    const newIndex = currentOrgIndex < organizations.length - 1 ? currentOrgIndex + 1 : 0;
    setCurrentOrgIndex(newIndex);
    dispatch(setSelectedOrganization(organizations[newIndex].id));
  };
  const { showSnackbar } = useSnackbar();
  const theme1 = useTheme();
  const isLargeScreen = useMediaQuery(theme1.breakpoints.up("lg")); // lg is usually 1280px
  const [mobileOpen, setMobileOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(
    localStorage.getItem("menu") || "Dashboard"
  );
  const [isFullScreen, setIsFullScreen] = useState(
    localStorage.getItem("fullscreen") === "true"
  );
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isMinimized, setIsMinimized] = useState(
    localStorage.getItem("isMinimized") === "true"
  );
  // When true, the drawer body swaps from the normal menu to the LLM Settings panel.
  const [showLLMSettings, setShowLLMSettings] = useState(false);

  const miniDrawerWidth = 72;
  const expandedDrawerWidth = 240;

  // Force the drawer open while the LLM Settings panel is showing — the 72px
  // mini rail is too narrow for the model cards.
  const isExpanded = showLLMSettings || !isMinimized || isHovered;
  const menuItems = [
    {
      key: "Home",
      label: "Home",
      path: "/dashboard",
      icon: DashboardIcon,
      roles: ["SUPER_ADMIN", "INSTITUTE_ADMIN", "TRAINER", "STUDENT", "INTERVIEWER"],
      organization: ["institute", "corporate"]
    },
    {
      key: "Programs",
      label: getLabel("PROGRAMS"),
      path: "/programs",
      icon: ListAltIcon,
      roles: ["SUPER_ADMIN", "INSTITUTE_ADMIN"],
      organization: ["institute", "corporate"]
    },
    {
      key: "Subjects",
      label: getLabel("SUBJECT"),
      path: "/category",
      icon: CategoryIcon,
      roles: ["SUPER_ADMIN", "INSTITUTE_ADMIN"],
      organization: ["institute", "corporate"]
    },
    {
      key: "Templates",
      label: "Templates",
      path: "/templates",
      icon: DashboardCustomizeIcon,
      roles: ["TRAINER", "INSTITUTE_ADMIN"],
      organization: ["institute", "corporate"]
    },
    {
      key: "Question Bank",
      label: getLabel("QUESTION_BANK"),
      path: "/questionPapers",
      icon: LibraryBooksIcon,
      roles: ["TRAINER", "INSTITUTE_ADMIN", "SUPER_ADMIN"],
      organization: ["institute", "corporate"]
    },
    {
      key: "Question Papers",
      label: getLabel("QUESTION_PAPER"),
      path: "/questionPaperBuilder",
      icon: NoteAddIcon,
      roles: ["TRAINER", "INSTITUTE_ADMIN", "SUPER_ADMIN"],
      organization: ["institute", "corporate"]
    },
    {
      key: "Exams",
      label: "Assessments",
      path: "/assesment",
      icon: AssignmentIcon,
      roles: ["STUDENT"],
      organization: ["institute", "corporate"]
    },
    {
      key: "Exam History",
      label: "Assessment History",
      path:
        // localStorage?.getItem("role") !== "STUDENT"
        //   ? 
        "/examHistory",
      // : "/studentExamHistory",
      icon: HistoryIcon,
      roles: ["STUDENT", "INSTITUTE_ADMIN", "TRAINER", "SUPER_ADMIN"],
      organization: ["institute", "corporate"]
    },
    {
      key: "Institutes",
      label: getLabel("INSTITUTE"),
      path: "/institutes",
      icon: BusinessIcon,
      roles: ["SUPER_ADMIN"],
      organization: ["institute", "corporate"]
    },
    {
      key: "Institute Admin",
      label: getLabel("INSTITUTE_ADMIN"),
      path: "/instituteAdmin",
      icon: AdminPanelSettingsIcon,
      roles: ["SUPER_ADMIN"],
      organization: ["institute", "corporate"]
    },
    {
      key: "Trainers",
      label: getLabel("TRAINER"),
      path: "/trainers",
      icon: SchoolIcon,
      roles: ["SUPER_ADMIN", "INSTITUTE_ADMIN"],
      organization: ["institute", "corporate"]
    },
    {
      key: "Students",
      label: getLabel("STUDENT"),
      path: "/students",
      icon: GroupIcon,
      roles: ["SUPER_ADMIN", "INSTITUTE_ADMIN", "TRAINER"],
      organization: ["institute", "corporate"]
    },
    {
      key: "Batches",
      label: getLabel("BATCHES"),
      path: "/batches",
      icon: BranchIcon,
      roles: ["SUPER_ADMIN", "INSTITUTE_ADMIN", "TRAINER"],
      organization: ["institute", "corporate"]
    },
    {
      key: "Super Admins",
      label: "Super Admins",
      path: "/superAdminList",
      icon: SecurityIcon,
      roles: ["SUPER_ADMIN"],
      organization: ["institute", "corporate"]
    },
    {
      key: "Audit Logs",
      label: "Audit Logs",
      path: "/auditLogs",
      icon: ArticleIcon,
      roles: ["SUPER_ADMIN"],
      organization: ["institute", "corporate"]
    },
    {
      key: "Interviewer",
      label: "Interviewer",
      path: "/interviewers-list",
      icon: MessagesSquare,
      roles: ["TRAINER", "INSTITUTE_ADMIN"],
      organization: ["corporate"]
    },
    {
      key: "Interview Scheduler",
      label: "Interview Scheduler",
      path: "/interview-scheduler-list",
      icon: CalendarCheck,
      roles: ["TRAINER", "INSTITUTE_ADMIN"],
      organization: ["corporate"]
    },
    {
      key: "Interview Schedules",
      label: "Interview Schedules",
      path: "/interview-schedule-list",
      icon: CalendarCheck2,
      roles: ["INTERVIEWER"],
      organization: ["corporate"]
    },
  ];

  // ==== Methods ===

  const handleMenuClick = (menu, path) => {
    setSelectedMenu(menu);
    localStorage.setItem("menu", menu);
    setIsClicked(true);
    setIsHovered(false);
    setTimeout(() => setIsClicked(false), 300);
    navigate(path);
    const itemsToRemove = [
      "currentPage",
      "searchvalue",
      "rowsPerPage",
      "TabValue",
      "Institute_Id_Filter",
      "Trainer_Id_Filter",
      "applyCategory",
      "applyLevel",
      "applyTestType",
      "applyInstitute",
      "applyTrainer",
      "applyTestTypeId",
      "conversation",
      "gen_id",
      "questionBankSearchKey",
      "questionBankCategory",
      "questionBankSubCategory",
      "questionBankLevel",
      "questionBankQuestionType",
      "questionBankPage",
      "batchesListSearch",
      "batchesListInstitute",
      "batchesListBatchName",
      "batchesListStatus",
      "applyInstituteCategory",
      "applyInstituteCategoryId",
      "applyLevel",
      "applyCategory",
      "applyQuestionType",
      "applyStatus",
      "applyTrainer",
      "applyTestType",
      "applyTestTypeId",
      "applyStudent",
      "applyStudentId",
      "programs_filter_programId",
      "programs_filter_programLabel",
      "programs_filter_programCodeChip",
      "programs_filter_code",
      "programs_filter_displayName",
      "programs_filter_status",
      "programs_filter_instituteId",
      "programs_filter_instituteName",
    ];
    itemsToRemove.forEach((item) => localStorage.removeItem(item));
  };

  // ===== API ====

  const handleLogout = async () => {
    stopTokenRefresh(); // stop the refresh loop; the old token expires on its own
    dispatch(clearChangeableItems()); // wipe store so next login gets a fresh slate
    localStorage.clear();
    localStorage.removeItem("Zoom");
    showSnackbar("success", "Logged out successfully");
    navigate("/");
  };

  // ====== UseEffects =====

  useEffect(() => {
    const updateFullScreen = () => {
      setIsFullScreen(localStorage.getItem("fullscreen") === "true");
    };

    const interval = setInterval(updateFullScreen, 200);

    window.addEventListener("storage", updateFullScreen);

    return () => {
      clearInterval(interval);
      window.removeEventListener("storage", updateFullScreen);
    };
  }, []);

  useEffect(() => {
    const currentMenu = menuItems.find(
      (item) => item.path === location.pathname
    );
    if (currentMenu) {
      setSelectedMenu(currentMenu.key);
      localStorage.setItem("menu", currentMenu.key);
    }
  }, [location.pathname]);

  // if (!token) {
  //   return <Navigate to="/login" replace />;
  // }

  return (
    <Box sx={{ display: "flex" }}>
      {!isFullScreen && isLargeScreen && (
        <Drawer
          variant="permanent"
          onMouseEnter={() => !isClicked && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          sx={{
            width: isExpanded ? expandedDrawerWidth : miniDrawerWidth,
            flexShrink: 0,
            transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            "& .MuiDrawer-paper": {
              width: isExpanded ? expandedDrawerWidth : miniDrawerWidth,
              transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              height: "100vh",
              overflowX: "hidden",
              overflowY: "hidden",
              boxSizing: "border-box",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              // background: "linear-gradient(180deg, #1c97e3 0%, #1565c0 100%)",
              color: "white",
              borderRight: "1px solid #e0e0e0",
            },
          }}
        >
          {showLLMSettings ? (
            <LLMSettingsPanel onClose={() => setShowLLMSettings(false)} />
          ) : (
            <>
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden", minHeight: 0 }}>
                <Box
                  sx={{
                    padding: "20px 10px",
                    marginTop: "10px",
                    borderBottom: "1px solid #e0e0e0",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: isExpanded ? "flex-start" : "center",
                    transition: "all 0.3s ease",
                    position: "relative",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    {isExpanded ? (
                      <Typography
                        sx={{
                          fontSize: "25px",
                          fontWeight: "bold",
                          color: "black",
                          transition: "all 0.3s ease",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Talent IQ
                      </Typography>
                    ) : (
                      <Box
                        component="img"
                        src="/window_Logo.png"
                        alt="Logo"
                        sx={{
                          width: "35px",
                          height: "35px",
                          objectFit: "contain",
                          transition: "all 0.3s ease",
                        }}
                      />
                    )}
                    {isExpanded && (
                      <IconButton
                        size="small"
                        onClick={() => {
                          const newMinimizedState = !isMinimized;
                          setIsMinimized(newMinimizedState);
                          localStorage.setItem("isMinimized", newMinimizedState);
                          setIsHovered(false);
                        }}
                        sx={{ color: "#717680" }}
                      >
                        {isMinimized ? <MenuIcon fontSize="small" /> : <MenuOpenIcon fontSize="small" />}
                      </IconButton>
                    )}
                  </Box>
                  {isExpanded && (
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "#0086c9",
                        whiteSpace: "nowrap",
                        opacity: isExpanded ? 1 : 0,
                        transition: "opacity 0.3s ease",
                      }}
                    >
                      Assessment Platform
                    </Typography>
                  )}
                </Box>

                {/* Organization Selector — SUPER_ADMIN only */}
                {isSuperAdmin && organizations.length > 0 && isExpanded && (
                  <Box
                    sx={{
                      px: 1.5,
                      py: 1,
                      borderBottom: "1px solid #e0e0e0",
                    }}
                  >
                    <FormControl fullWidth size="small">
                      <Select
                        labelId="org-select-label"
                        id="org-select"
                        value={selectedOrganizationId || ""}
                        onChange={(e) => {
                          dispatch(setSelectedOrganization(e.target.value));
                        }}
                        sx={{
                          fontSize: "13px",
                          borderRadius: "8px",
                          backgroundColor: "#f8fafc",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#d0d7de",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1976d2",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1976d2",
                          },
                          "& .MuiSelect-select": {
                            py: "6px",
                          },
                        }}
                      >
                        {organizations.map((org) => (
                          <MenuItem
                            key={org.id}
                            value={org.id}
                            sx={{ fontSize: "13px" }}
                          >
                            {org.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                )}

                {/* Dynamic List */}
                <Box sx={{
                  overflowX: "hidden",
                  overflowY: "auto",
                  flex: 1,
                  minHeight: 0,
                  "&::-webkit-scrollbar": { width: "4px" },
                  "&::-webkit-scrollbar-thumb": { backgroundColor: "#1976d2", borderRadius: "4px" }
                }}>
                  <List>
                    {menuItems
                      .filter((item) => item.roles.includes(role) &&
                        (organization === "null" || item?.organization?.includes(organization))
                      )
                      .map((item) => {
                        const Icon = item.icon;
                        const isSelected = selectedMenu === item.key;

                        return (
                          <ListItem
                            button
                            key={item.key}
                            onClick={() => handleMenuClick(item.key, item.path)}
                            sx={{
                              cursor: "pointer",
                              backgroundColor: isSelected
                                ? "#f0f9ff"
                                : "transparent",
                              borderRadius: "10px",
                              "&:hover": {
                                backgroundColor: isSelected ? "#f0f9ff" : "#f0f9ff",
                              },
                              display: "flex",
                              justifyContent: isExpanded ? "flex-start" : "center",
                              px: isExpanded ? 2 : 1,
                              mx: 1,
                              gap: isExpanded ? "12px" : "0px",
                              transition: "all 0.3s ease",
                              minHeight: 48,
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: "fit-content",
                                justifyContent: "center",
                              }}
                            >
                              <Icon
                                style={{ color: isSelected ? "#1565c0" : "#717680", }}
                                sx={{
                                  color: isSelected ? "#1565c0" : "#717680",
                                  fontSize: isExpanded ? 24 : 26,
                                  transition: "all 0.3s ease",
                                }}
                              />
                            </ListItemIcon>
                            <ListItemText
                              sx={{
                                color: isSelected ? "#1565c0" : "#414651",
                                fontWeight: "bold",
                                opacity: isExpanded ? 1 : 0,
                                width: isExpanded ? "auto" : 0,
                                transition: "all 0.3s ease",
                                m: 0,
                              }}
                              primaryTypographyProps={{
                                fontSize: "14px",
                                fontWeight: 600,
                                whiteSpace: "nowrap",
                              }}
                              primary={item.label}
                            />
                          </ListItem>
                        );
                      })}
                  </List>
                </Box>
              </Box>
              <Box
                sx={{
                  borderRadius:
                    localStorage.getItem("role") !== "SUPER_ADMIN" && "16px",
                  px: 0.5,
                  color: localStorage.getItem("role") !== "SUPER_ADMIN" && "white",
                  mb: 2,
                  overflow: "hidden",
                }}
              >
                {localStorage.getItem("role") !== "SUPER_ADMIN" &&
                  localStorage.getItem("CollegeName") !== "" && (
                    <Tooltip
                      title={localStorage.getItem("CollegeName")}
                      arrow
                      placement="top"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "primary.main",
                            color: "white",
                            fontSize: 13,
                            fontWeight: 500,
                          },
                        },
                        arrow: {
                          sx: {
                            color: "primary.main",
                          },
                        },
                      }}
                    >
                      <Box
                        display="flex"
                        alignItems={"center"}
                        gap={1}
                        padding={"0px 10px"}
                        justifyContent={isExpanded ? "flex-start" : "center"}
                      >
                        <BusinessIcon sx={{ color: "#717680", fontSize: 28 }} />
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            letterSpacing: "0.5px",
                            textShadow: "1px 1px 3px rgba(0,0,0,0.2)",
                            color: "#414651",
                            opacity: isExpanded ? 1 : 0,
                            width: isExpanded ? "auto" : 0,
                            transition: "all 0.3s ease",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          {localStorage.getItem("CollegeShortName")}
                        </Typography>
                      </Box>
                    </Tooltip>
                  )}

                {/* Replaced the Card with UserProfileDropdown component */}
                <Box padding={isExpanded ? "10px" : "10px 5px"}>
                  <UserProfileDropdown
                    handleLogout={handleLogout}
                    isHovered={isExpanded}
                    onOpenLLMSettings={() => setShowLLMSettings(true)}
                  />
                </Box>
              </Box>
            </>
          )}
        </Drawer>
      )}
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        {/* Main Content */}
        <Box
          sx={{
            flexGrow: 1,
            p: 1,
          }}
        >
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/viewProgram" element={<ViewProgram />} />
            <Route path="/assesment" element={<Assesment />} />
            <Route path="/questionPapers" element={<Setting />} />
            <Route path="/questionPaperBuilder" element={<QuestionPaperBuilder />} />
            <Route path="/questionPaperBuilder/create" element={<CreateQuestionPaper />} />
            <Route path="/questionPaperBuilder/add-questions" element={<AddQuestionsToPaper />} />
            <Route path="/questionPaperBuilder/view" element={<QuestionPaperView />} />
            <Route path="/templates" element={<TemplatesList />} />
            <Route path="/templates/create" element={<TemplateCreate />} />
            <Route path="/studentAttempts" element={<QuestionPaperView />} />
            <Route path="/studentResults" element={<QuestionPaperView />} />
            <Route path="/questionBank/view" element={<QuestionBankView />} />
            <Route path="/instruction" element={<Instruction />} />
            <Route path="/test" element={<Test />} />
            <Route path="/studentExamHistory" element={<UserReview />} />
            <Route path="/examOverview" element={<TestDetail />} />
            <Route path="/dashboard/examOverview" element={<TestDetail />} />
            <Route path="/institutes" element={<Institutes />} />
            <Route path="/category/institutes" element={<Institutes />} />
            <Route path="/instituteAdmin" element={<InstituteAdmin />} />
            <Route path="/students" element={<StudentsList />} />
            <Route path="/superAdminList" element={<SuperAdminsList />} />
            <Route path="/trainers" element={<TrainersList />} />
            <Route path="/batches" element={<BatchesList />} />
            <Route path="/interviewers-list" element={<InterviewList />} />
            <Route path="/interview-scheduler-list" element={<InterviewScheduler />} />
            <Route path="/view-interviewer" element={<ViewInterviewer />} />
            <Route path="/interviewer-history" element={<InterviewerHistory />} />
            <Route path="/add-interviewer" element={<AddInterviewer />} />
            <Route path="/viewBatch" element={<ViewBatch />} />
            <Route path="/addInstitute" element={<AddInstitute />} />
            <Route path="/addInstituteAdmin" element={<AddInstituteAdmin />} />
            <Route path="/addTrainer" element={<AddTrainer />} />
            <Route path="/addStudent" element={<AddStudent />} />
            <Route path="/add-interview-scheduler" element={<AddInterviewScheduler />} />
            <Route path="/add-interview-scheduler" element={<AddInterviewScheduler />} />
            <Route path="/addCategory" element={<AddCategory />} />
            <Route path="/viewQuestionPaper" element={<ViewTestDetails />} />
            <Route
              path="/dashboard/viewQuestionPaper"
              element={<ViewTestDetails />}
            />
            <Route path='/interview-schedule-list' element={<InterviewFeedbackList />} />
            <Route path='/interview-feedback' element={<InterviewFeedback />} />
            <Route path="/addSuperAdmin" element={<AddSuperAdmin />} />
            <Route path="/category" element={<Category />} />
            <Route path="/category/view" element={<ViewCategory />} />
            <Route path="/viewstudent" element={<ViewStudent />} />
            <Route path="/view-interview-scheduler" element={<ViewInterviewScheduler />} />
            <Route path="/trainerViewResults" element={<TrainerViewReview />} />
            <Route
              path="/dashboard/trainerViewResults"
              element={<TrainerViewReview />}
            />
            <Route path="/examHistory" element={<StudentsResultList />} />
            <Route
              path="/dashboard/examHistory"
              element={<StudentsResultList />}
            />
            <Route path="/viewTrainer" element={<ViewTrainer />} />
            <Route path="/trainers/questionPapers" element={<Setting />} />
            <Route
              path="/viewInstituteAdmin"
              element={<ViewInstituteAdmin />}
            />
            <Route path="/viewSuperAdmin" element={<ViewSuperAdmin />} />
            <Route path="/viewInstitute" element={<ViewInstitute />} />
            <Route path="/changePassword" element={<ChangePassword />} />
            <Route path="/preview" element={<QuetionPaperPreview />} />
            <Route path="/previewTable" element={<PreviewTable />} />
            <Route path="/subCategory" element={<AddSubcategory />} />
            <Route path="/add" element={<Add />} />
            <Route path="/auditLogs" element={<AuditLogs />} />
          </Routes>
        </Box>
        {!hideFooter && (
          <Box>
            <Footer />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AuthenticatedRoutes;
